import { ValidationError, ObjectSchema } from 'yup';
import FormValueTypes from '../types/FormValueTypes';

/**
 * Returns an object with errors for the provided object, validating it
 * with the provided schema. An empty object will be returned if no
 * errors occur.
 *
 * @param obj - The object to validate
 * @param schema - The validation schema to use
 */
function validate(
  obj: { [key: string]: FormValueTypes },
  schema: ObjectSchema,
): { [key: string]: string } {
  const errors: { [key: string]: string } = {};
  try {
    schema.validateSync(obj, { abortEarly: false });
  } catch (e) {
    const innerErrors = e.inner as Array<ValidationError>;
    innerErrors.forEach((curEr: ValidationError) => {
      errors[curEr.path] = curEr.message;
    });
  }
  return errors;
}

export default validate;
